import { createTheme } from '@mui/material/styles';
// import { hover, disabled, focus, active } from './customs/mixins/helpers';
import {
	scrollbar as scrollbarMixin,
	hexWithOpacity,
	mixColors,
	adjustLightness,
	grow,
} from './mixins';

// TODO check colors and theme
const themeColors = {
	white: '#ffffff',
	lightBlue: '#99b4d6',
	blue: '#2b98f0',
	darkBlue: '#0b2746',
	gray: '#afaeb3',
	darkerGray: '#686764',
	mustard: '#d5a021',
	light: '#ede7d9',
	red: '#f41100',
	bordeaux: '#810341',
	dark: '#303332',
	black: '#000206',
	green: '#198754',
	yellow: '#ffc107',
	teal: '#008080',
	lighterBlue: mixColors('#99b4d6', '#ffffff', 30),
	lightestBlue: mixColors('#99b4d6', '#ffffff', 20),
	lightGray: mixColors('#afaeb3', '#ffffff', 30),
	lighterGray: mixColors('#afaeb3', '#ffffff', 20),
	darkGray: adjustLightness('#afaeb3', -10),
} as const;

type ThemeColors = typeof themeColors;

const themeFonts = {
	primary: `Ubuntu, sans-serif`,
	secondary: `Roboto, sans-serif`,
} as const;

const themeSizes = {
	big: '1.6em',
	medium: '1.5em',
	normal: '1.3em',
	small: '1.1em',
} as const;

const themeBorderRadius = {
	small: '0.2em',
	medium: '0.5em',
	large: '1em',
} as const;

const themeVariables = {
	baseSize: '11px',
	baseSizeMobile: '0.9em',
	sizes: themeSizes,
	borderRadius: themeBorderRadius,
	inputs: {
		fontSize: themeSizes.normal,
		paddingVertical: '0.2em',
	},
	bodyPadding: '20px',
	accordionBorderRadius: '6px',
} as const;

const themeTextStyles = {
	fonts: themeFonts,
	textBold: {
		fontWeight: 'bold',
	},
	textOblique: {
		fontStyle: 'italic',
	},
	fontPrimaryBold: {
		fontFamily: themeFonts.primary,
		fontWeight: 'bold',
	},
	fontSecondaryOblique: {
		fontFamily: themeFonts.secondary,
		fontStyle: 'italic',
		fontWeight: 300,
	},
} as const;

type ThemeMixins = {
	scrollbar: typeof scrollbarMixin;
	// hover: typeof hover;
	// disabled: typeof disabled;
	// focus: typeof focus;
	// active: typeof active;
	hexWithOpacity: typeof hexWithOpacity;
	mixColors: typeof mixColors;
	adjustLightness: typeof adjustLightness;
	grow: typeof grow;
};

const themeMixins: ThemeMixins = {
	scrollbar: scrollbarMixin,
	// hover,
	// disabled,
	// focus,
	// active,
	hexWithOpacity,
	mixColors,
	adjustLightness,
	grow,
};

declare module '@mui/material/styles' {
	interface Theme {
		colors: ThemeColors;
		variables: typeof themeVariables;
		textStyles: typeof themeTextStyles;
	}
	interface ThemeOptions {
		colors?: Partial<ThemeColors>;
		variables?: Partial<typeof themeVariables>;
		textStyles?: Partial<typeof themeTextStyles>;
	}
	interface Mixins extends ThemeMixins {}
	interface MixinsOptions extends Partial<ThemeMixins> {}
}

export const theme = createTheme({
	colors: themeColors,
	variables: themeVariables,
	textStyles: themeTextStyles,
	mixins: themeMixins,
});
